import './../../App.css';
import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
// import { ErrorBoundary } from 'react-error-boundary';
// import { ErrorBox } from '../ErrorBox';
import { Box } from '@mui/material';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { DisplayedCikContext, SelectedDatapointContext } from '../../common/Contexts';
import { ampli, decodeDatapoint, ProvenancePane, RevelataFooter } from '../../common';

export function ProvenanceViewer() {
    const [params, setSearchParams] = useSearchParams();
    const [selectedDatapoint, setSelectedDatapoint] = useState(null);
    const [displayedCik, setDisplayedCik] = useState(null);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const { authStatus } = useAuthenticator((context) => [context.authStatus]);

    useEffect( 
        () => {
            const pb = params.get('d');
            const dp = decodeDatapoint(pb);
            setSelectedDatapoint({dp: dp});
            setDisplayedCik(dp['cik']);            
            ampli.dataAudit( {                
                "Provenance Details": [
                    dp['cik'],
                    dp['accNo'], 
                    dp['seqNo'].toString(), 
                    JSON.stringify(dp['xpathNodes'])
                ], 
                "Provenance Caller": "docviewer",
                "Filing Date": dp['filingDate'],
                "Reporting Period": dp['reportingPeriod'],
                "Sentence":  dp['sentence'],
                "Form Type": dp['formType'],
                "Doc Type": dp['docType'],
                }
            ); //@@@ TODO Deprecate in favor of dkDataAudit
            ampli.dkDataAudit( {                
                "Provenance Details": [
                    dp['cik'],
                    dp['accNo'], 
                    dp['seqNo'].toString(), 
                    JSON.stringify(dp['xpathNodes'])
                ], 
                "Provenance Caller": "docviewer",
                "Filing Date": dp['filingDate'],
                "Reporting Period": dp['reportingPeriod'],
                "Sentence":  dp['sentence'],
                "Form Type": dp['formType'],
                "Doc Type": dp['docType'],
                }
            );
        }, [params]
    );

    return (        
        <Box sx={{
            height: "100%", 
            width: "100%",
            display: "flex", 
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column"
        }}>
            <Box sx={{
                height: authStatus !== 'authenticated' ? "80%" : "100%", 
                maxHeight: authStatus !== 'authenticated' ? "80%" : "100%",
                width: "50%",         
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                flexShrink: 1
            }}>                                
                {/* <ErrorBoundary FallbackComponent={ErrorBox}> */}
                    <DisplayedCikContext.Provider value={[displayedCik, setDisplayedCik]}>
                        <SelectedDatapointContext.Provider value={[selectedDatapoint, setSelectedDatapoint]}>
                            <ProvenancePane />
                        </SelectedDatapointContext.Provider>        
                    </DisplayedCikContext.Provider>                
                {/* </ErrorBoundary> */}
            </Box>                    
            {authStatus !== 'authenticated' && <RevelataFooter />}
        </Box>
        
    )
}